export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "powerbet-themeWrapLive" */'./LiveThemeImporter'),
    ThemeImporter: () => import(/* webpackChunkName: "powerbet-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "powerbet-themeWrapLive" */'./LiveThemeImporter'),
    ThemeImporter: () => import(/* webpackChunkName: "powerbet-themeWrap" */'./ThemeImporter'),
  },
};
